import { useCallback, useEffect } from 'react';
import { getVideoElementFromRef } from '@/utils/video-player';
import { useVideoPlayerContext } from '../VideoPlayerProvider';

export function usePlaybackRate() {
    const { activeMediaRef, emitter, playbackRate, setPlaybackRate } =
        useVideoPlayerContext();

    useEffect(() => {
        const syncFromVideo = () => {
            const videoElement = getVideoElementFromRef(activeMediaRef);
            if (videoElement) setPlaybackRate(videoElement.playbackRate);
        };

        const unsubscribe = emitter.on('ratechange', syncFromVideo);
        syncFromVideo();
        return unsubscribe;
    }, [activeMediaRef, emitter, setPlaybackRate]);

    const setRate = useCallback(
        (rate: number) => {
            const videoElement = getVideoElementFromRef(activeMediaRef);
            if (!videoElement) return;
            videoElement.playbackRate = rate;
            setPlaybackRate(videoElement.playbackRate);
        },
        [activeMediaRef, setPlaybackRate],
    );

    return { playbackRate, setRate };
}
